import React from 'react';
import { PlayerData, CardData } from '../types/GameTypes';
import './PlayerDashboard.css';

interface PlayerDashboardProps {
  player: PlayerData | null;
  marketCards: CardData[];
  onHeal: () => void;
  onPlayCard: (cardId: string) => void;
}

const PlayerDashboard: React.FC<PlayerDashboardProps> = ({ player, marketCards, onHeal, onPlayCard }) => {
  if (!player) {
    return <div className="player-dashboard">Loading player data...</div>;
  }

  return (
    <div className="player-dashboard">
      <h2>Player Dashboard for {player.viking.playerId}</h2>

      <div className="player-stats">
        <h3>Stats</h3>
        <p>Health: {player.viking.health} / {player.viking.maxHealth}</p>
        <p>Gold: {player.viking.gold}</p>
        <p>Ear Tokens: {player.viking.earTrophies}</p>
        <p>Actions: {player.viking.remainingActions} / {player.viking.actionsPerTurn}</p>
      </div>

      <div className="player-actions">
        <h3>Actions</h3>
        {player.viking.canHeal && (
          <button onClick={onHeal} className="heal-button">
            Heal (1 HP) - 1 Action
          </button>
        )}
      </div>

      <div className="player-hand">
        <h3>Hand</h3>
        <div className="cards">
          {player.hand.map(card => (
            <div key={card.id} className="card" onClick={() => onPlayCard(card.id)}>
              <h4>{card.name}</h4>
              <p>{card.description}</p>
              <p>Cost: {card.cost}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="deck-info">
          <h3>Deck</h3>
          <p>Cards remaining: {player.deckCount}</p>
          <p>Discard pile: {player.discardCount}</p>
      </div>

      <div className="card-market">
        <h3>Card Market</h3>
        <div className="cards">
          {marketCards.map(card => (
            <div key={card.id} className="card market-card">
              <h4>{card.name}</h4>
              <p>{card.description}</p>
              <p>Cost: {card.cost}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlayerDashboard;